import React, { useRef, Children } from 'react';
import { motion, useInView, Variant } from 'framer-motion';
interface ScrollRevealProps {
  children: ReactNode;
  width?: 'fit-content' | '100%';
  delay?: number;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
  duration?: number;
  className?: string;
  staggerChildren?: number;
}
export function ScrollReveal({
  children,
  width = 'fit-content',
  delay = 0,
  direction = 'up',
  duration = 0.5,
  className = '',
  staggerChildren = 0
}: ScrollRevealProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  const getVariants = () => {
    const distance = 50;
    const hidden: any = {
      opacity: 0
    };
    if (direction === 'up') hidden.y = distance;
    if (direction === 'down') hidden.y = -distance;
    if (direction === 'left') hidden.x = distance;
    if (direction === 'right') hidden.x = -distance;
    const visible: any = {
      opacity: 1,
      x: 0,
      y: 0,
      transition: {
        duration,
        delay,
        ease: 'easeOut',
        ...(staggerChildren ? {
          staggerChildren
        } : {})
      }
    };
    return {
      hidden,
      visible
    };
  };
  return <div ref={ref} style={{
    width
  }} className={className} data-id="element-312">
      <motion.div variants={getVariants()} initial="hidden" animate={isInView ? 'visible' : 'hidden'} data-id="element-313">
        {children}
      </motion.div>
    </div>;
}